import script from "./DefaultRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultRadio.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__